"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertor = exports.taskFromOperationNode = void 0;
const common_1 = require("@finley-technologies/common");
const converterUtils_1 = require("../converterUtils");
const types_1 = require("./types");
const taskToOperationNode = (task) => {
    return (0, converterUtils_1.newOperationNode)(types_1.nodeType, task);
};
const taskFromOperationNode = ({ operationNode, }) => {
    const { configuration } = operationNode;
    return {
        ...configuration,
    };
};
exports.taskFromOperationNode = taskFromOperationNode;
exports.convertor = {
    operation: 'join',
    nodeType: types_1.nodeType,
    taskToOperationNode,
    taskFromOperationNode: exports.taskFromOperationNode,
    getInputSlugs: (task) => [task.srcArtifactSlug, task.joinArtifactSlug],
    toTransformation: (task, resolveDef) => {
        const { srcArtifactSlug, joinArtifactSlug, ...restOfJoinParams } = task;
        const srcDataTape = resolveDef(srcArtifactSlug);
        const joinDataTape = resolveDef(joinArtifactSlug);
        if (srcDataTape.isValid && joinDataTape.isValid) {
            (0, common_1.finleyAssert)(srcDataTape.data && joinDataTape.data, 'TapeDefinition is null for join operation inputs ');
            return {
                isValid: true,
                data: {
                    srcDataTape: srcDataTape.data,
                    joinDataTape: joinDataTape.data,
                    ...restOfJoinParams,
                },
            };
        }
        const errors = [];
        if (!srcDataTape.isValid) {
            errors.push(...srcDataTape.errors);
        }
        if (!joinDataTape.isValid) {
            errors.push(...joinDataTape.errors);
        }
        return {
            isValid: false,
            errors,
        };
    },
};
//# sourceMappingURL=converter.js.map